import { useContext } from 'react';
import { Context } from '../context/portalUrlContext';

/** hook to return the url of the portal. */
const usePortalUrl = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error('usePortalUrl must be used within a Provider');
  }

  return context;
};

export default usePortalUrl;
